var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconInstagramCircle = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,0c165.7,0,300,134.3,300,300S465.7,600,300,600S0,465.7,0,300S134.3,0,300,0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M367.2,149.3H232.8c-45.6,0-82.8,37.1-82.8,82.8v134.4c0,45.7,37.1,82.8,82.8,82.8h134.4 c45.7,0,82.8-37.1,82.8-82.8V232.1C450,186.5,412.9,149.3,367.2,149.3z M423.4,366.6c0,31-25.2,56.2-56.2,56.2H232.8 c-31,0-56.2-25.2-56.2-56.2V232.1c0-31,25.2-56.2,56.2-56.2h134.4c31,0,56.2,25.2,56.2,56.2L423.4,366.6L423.4,366.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300,222.1c-42.6,0-77.3,34.7-77.3,77.3c0,42.6,34.7,77.3,77.3,77.3s77.3-34.7,77.3-77.3 C377.3,256.7,342.6,222.1,300,222.1z M300,350c-27.9,0-50.7-22.7-50.7-50.7c0-27.9,22.7-50.7,50.7-50.7 c27.9,0,50.7,22.7,50.7,50.7C350.7,327.3,327.9,350,300,350z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M380.5,199.5c-5.1,0-10.2,2.1-13.8,5.7c-3.6,3.6-5.7,8.7-5.7,13.8c0,5.1,2.1,10.2,5.7,13.8 c3.6,3.6,8.7,5.7,13.8,5.7c5.1,0,10.2-2.1,13.8-5.7c3.6-3.6,5.7-8.7,5.7-13.8c0-5.1-2.1-10.2-5.7-13.8 C390.7,201.6,385.7,199.5,380.5,199.5z"
  })), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconInstagramCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-instagram-circle.e6daf577.svg";
export { ForwardRef as ReactComponent };